define('tracks/track-state',["require", "exports", "../util/observable", "../util/pubsub"], function (require, exports, observable_1, pubsub_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.highlight = exports.labelUpdates = exports.trimUpdates = exports.focusUpdates = void 0;
    /**
     * Subscribe to track focus updates
     */
    exports.focusUpdates = new pubsub_1.PubSub();
    /**
     * Subscribe to track trim updates
     */
    exports.trimUpdates = new pubsub_1.PubSub();
    /**
     * Subscribe to track label updates
     */
    exports.labelUpdates = new pubsub_1.PubSub();
    /**
     * Subscribe to track highlight updates
     */
    exports.highlight = new observable_1.Observable(undefined);
});
//# sourceMappingURL=/assets/javascripts/tracks/track-state.js.map;
